import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCourses = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .6,
			d: "M11.0808 20.6303C11.3366 20.6852 11.5065 20.7164 11.6777 20.7314C11.891 20.7501 12.1056 20.7501 12.3189 20.7314C12.4901 20.7164 12.66 20.6852 12.9157 20.6303V9.70435C12.5842 9.77798 12.4124 9.81534 12.2387 9.83057C12.0787 9.84459 11.9179 9.84459 11.7579 9.83057C11.5842 9.81534 11.4124 9.77798 11.0808 9.70435L11.0808 20.6303Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9175 9.70424C12.9299 9.70149 12.9425 9.69868 12.9554 9.69583L17.5775 8.66868C18.4937 8.46507 18.9519 8.36327 19.3113 8.48169C19.6265 8.58551 19.8937 8.79977 20.0634 9.08498C20.257 9.41025 20.257 9.87953 20.257 10.8181V16.6449C20.257 17.4853 20.257 17.9054 20.1081 18.2521C19.9767 18.558 19.7647 18.8223 19.4947 19.0169C19.1886 19.2374 18.7784 19.3285 17.9581 19.5108L13.2738 20.5517C13.1373 20.5821 13.0204 20.6081 12.9175 20.6302L12.9175 9.70424Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0826 9.70424V20.6302C10.9796 20.6081 10.8628 20.5821 10.7264 20.5518L6.04198 19.5108C5.22169 19.3285 4.81153 19.2374 4.50537 19.0169C4.23532 18.8223 4.02327 18.558 3.89194 18.2521C3.74304 17.9054 3.74304 17.4853 3.74304 16.6449L3.74304 10.8181C3.74304 9.87953 3.74304 9.41025 3.93663 9.08498C4.10637 8.79977 4.37346 8.58551 4.6887 8.48169C5.04822 8.36327 5.50634 8.46507 6.42255 8.66868L11.0447 9.69583C11.0575 9.69868 11.0702 9.70149 11.0826 9.70424Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M11.998 3.22949C14.8833 3.22949 15.0635 6.32863 15.0635 7.87793C15.0634 8.37869 14.8723 8.87771 14.6172 9.32617L12.9551 9.69629C12.9425 9.69909 12.9301 9.70238 12.918 9.70508V17.1729H12.916V9.70508C12.5846 9.7787 12.4119 9.81583 12.2383 9.83105C12.0784 9.84504 11.9176 9.84507 11.7578 9.83105C11.5846 9.81586 11.4131 9.77837 11.083 9.70508L11.0449 9.69629L9.37891 9.3252C9.12407 8.87697 8.93274 8.37834 8.93262 7.87793C8.93262 6.32867 9.11297 3.22965 11.998 3.22949Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgCourses);
export { ForwardRef as ReactComponent };
